import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { NavToolbarComponent } from './nav-toolbar.component';
import { MatIconModule } from '@angular/material/icon';
import { UIRouterModule } from '@uirouter/angular';
import { FlexModule } from '@angular/flex-layout';

@NgModule({
    declarations: [
        NavToolbarComponent
    ],
    entryComponents: [
        NavToolbarComponent
    ],
    exports: [
        NavToolbarComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        UIRouterModule,
        FlexModule
    ],
})
export class NavToolbarModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            NavToolbarComponent
        ]);
    }
}
